'use strict';

/**
 * Changes from base:
 * 1. Change path to the icon
 * 2. Added onIcon
 * 3. AddtoWishlist - onIcon and icon
 */

var base = require('wishlists/product/wishlistHeart');
var ga4 = require('../analytics/ga4');
var metaCapi = require('../analytics/metaCapi');

var ATTRIBUTES = {
    STATUS: {
        SUCCESS: 'success',
        ERROR: 'error'
    },
    CLASSES: {
        NO_DISPLAY:'d-none',
        WISHLIST: '.wishlistTile',
        BUTTON_NOT_WISH: '.not-wishlist',
        BUTTON_WISH: '.on-wishlist',
        PRODUCT_DETAIL: '.product-detail'
    },
    SELECTORS: {
        ON_SELECT: '.options-select option:selected',
        PRODUCT_OPTION: '.product-option'
    },
    DATA_ATTRIBUTES: {
        OPTION_ID: 'data-option-id',
        VALUE_ID: 'data-value-id'
    }
};

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 * @param {Object} onIcon - icon to show when already on the wishlist
 * @param {Object|null} ga4Item - GA4 item payload to send on success
 */
function displayMessageAndChangeIcon(data, icon, onIcon, ga4Item) {
    $.spinner().stop();

    var status;

    if (data.success) {
        status = ATTRIBUTES.STATUS.SUCCESS;
        icon.addClass(ATTRIBUTES.CLASSES.NO_DISPLAY);
        onIcon.removeClass(ATTRIBUTES.CLASSES.NO_DISPLAY);

        if (ga4Item && typeof window !== 'undefined' && typeof window.gtag === 'function') {
            ga4.sendEvent('add_to_wishlist', {
                currency: ga4.getCurrency(),
                value: ga4.parseDecimal(ga4Item.price) * (ga4Item.quantity || 1),
                items: [ga4Item]
            });

            metaCapi.track('AddToWishlist', {
                currency: ga4.getCurrency(),
                value: ga4.parseDecimal(ga4Item.price) * (ga4Item.quantity || 1),
                content_type: 'product',
                contents: [
                    {
                        id: ga4Item.item_id,
                        quantity: ga4Item.quantity || 1,
                        item_price: ga4.parseDecimal(ga4Item.price)
                    }
                ]
            });
        }
    } else {
        status = ATTRIBUTES.STATUS.ERROR;
    }

    $.alert(data.msg, status, false);
}

/**
 * Handles adding a product to the wishlist
 */
base.addToWishlist = function() {
    $('body').off('click', ATTRIBUTES.CLASSES.WISHLIST).on('click', ATTRIBUTES.CLASSES.WISHLIST, function (e) {
        e.preventDefault();
        var icon = $(this).find(ATTRIBUTES.CLASSES.BUTTON_NOT_WISH);
        var onIcon = $(this).find(ATTRIBUTES.CLASSES.BUTTON_WISH);
        var url = $(this).attr('href');
        var pid =
            $(this).closest('.product').data('pid') ||
            $(this).closest('.product-detail').data('pid') ||
            $(this).closest('.product-tile').data('pid') ||
            $(this).closest('[data-pid]').data('pid');
        var $context = $(this).closest('.product, .product-detail, .product-tile').first();
        var name =
            $context.find('.product-name').first().text().trim() ||
            $context.find('.pdp-link a[data-type="name"]').first().text().trim() ||
            $(this).attr('title') ||
            '';
        var price = ga4.getFirstPriceValue($context);
        var optionId = $(this).closest(ATTRIBUTES.CLASSES.PRODUCT_DETAIL).find(ATTRIBUTES.SELECTORS.PRODUCT_OPTION).attr(ATTRIBUTES.DATA_ATTRIBUTES.OPTION_ID);
        var optionVal = $(this).closest(ATTRIBUTES.CLASSES.PRODUCT_DETAIL).find(ATTRIBUTES.SELECTORS.ON_SELECT).attr(ATTRIBUTES.DATA_ATTRIBUTES.VALUE_ID);

        optionId = optionId || null;
        optionVal = optionVal || null;

        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                displayMessageAndChangeIcon(data, icon, onIcon, {
                    item_id: String(pid),
                    item_name: name || String(pid),
                    price: price,
                    quantity: 1
                });
            },
            error: function (err) {
                displayMessageAndChangeIcon(err, icon, onIcon, null);
            }
        });
    });
}

module.exports = base;
